import { cn } from "@/lib/utils";

// Large slanted visual block for coaches (Corey Phillips reference)
export const CoachBlock = ({ item, reverse = false }) => {
  const name = item.name || item.title || "Coach";
  const firstName = name.split(" ")[0];
  return (
    <div data-testid="coach-feature-block" className="grid items-stretch overflow-hidden rounded-xl border border-border bg-card md:grid-cols-2">
      <div className={cn("relative min-h-[280px] md:min-h-[360px]", reverse && "md:order-2")}>
        <img src={item.image_url} alt={name} loading="lazy" className="absolute inset-0 h-full w-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 h-2 bg-brand md:hidden" />
      </div>
      <div className={cn("relative flex flex-col justify-center p-7 sm:p-9", reverse && "md:order-1")}>
        <div className="font-condensed text-xs font-semibold uppercase tracking-[0.25em] text-brand">{item.role}</div>
        <h3 className="mt-2 display-title text-4xl sm:text-5xl">{name}</h3>
        <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{item.bio}</p>
        {Array.isArray(item.specialties) && (
          <div className="mt-4 flex flex-wrap gap-2">
            {item.specialties.map((s) => (
              <span key={s} className="rounded-full border border-border px-3 py-1 text-xs font-medium uppercase tracking-wide text-muted-foreground">{s}</span>
            ))}
          </div>
        )}
        {item.cta_url && (
          <a href={item.cta_url} target="_blank" rel="noopener noreferrer" data-testid="coach-feature-book-button" className="mt-6 inline-flex w-fit items-center rounded-md bg-brand px-5 py-3 text-sm font-semibold uppercase tracking-wide text-white hover:bg-[hsl(var(--brand-red-deep))] transition-colors">Train with {firstName}</a>
        )}
      </div>
    </div>
  );
};
